import React, { ReactNode } from "react";

export const StickyContainer: React.FC<{ id: string; children: ReactNode }> = (
    props
) => {
    return (
        <div className={`sticky-container-${props.id}`}>{props.children}</div>
    );
};
